/* eslint-disable quotes */
<template>
  <v-app id="main">
    <v-skeleton-loader
      v-if="!loaded"
      type="card-avatar, article, actions"
    ></v-skeleton-loader>
    <router-view v-else></router-view>
  </v-app>
</template>

<script>
// import axios from "axios";
import iframeResizerContentWindow from "iframe-resizer";
import { mapState, mapGetters } from "vuex";
import common from "./helpers/common";

export default {
  data() {
    return {
      loaded: false,
      timer: null,
    };
  },
  computed: {
    ...mapState({
      dataToken: (state) => state.auth.data,
    }),
    isTokenExpired() {
      return common.getDiffSecond(this.dataToken.expires_at);
    },
  },
  watch: {
    async isTokenExpired(newValue) {
      if (newValue < 0) {
        console.log("token expired, ad reload token");
        await this.handleToken();
      }
    },
  },
  async created() {
    await this.handleToken();
  },
  async mounted() {
    this.resizeParent();
  },
  methods: {
    async handleToken() {
      // axios.defaults.baseURL = process.env.VUE_APP_ROOT_API_SERVER;
      // if (this.isTokenExpired <= 0) {
      //   // if (this.dataToken.refresh_token) {
      //   //   const result = await axios.post("/api/v2/oauth/token", {
      //   //     grant_type: "refresh_token",
      //   //     client_id: process.env.VUE_APP_CLIENT_ID,
      //   //     client_secret: process.env.VUE_APP_CLIENT_SECRET,
      //   //     refresh_token: this.dataToken.refresh_token,
      //   //     scope: "*",
      //   //   });
      //   //   const data = await result.data;
      //   //   this.$store.dispatch("auth/setToken", data);
      //   // } else {
      //   // const result = await axios.post("/api/v2/oauth/token", {
      //   //   grant_type: "password",
      //   //   client_id: process.env.VUE_APP_CLIENT_ID,
      //   //   client_secret: process.env.VUE_APP_CLIENT_SECRET,
      //   //   username: process.env.VUE_APP_EMAIL,
      //   //   password: process.env.VUE_APP_PASSWORD,
      //   //   scope: "*",
      //   // });
      //   // const data = await result.data;
      //   // this.$store.dispatch("auth/setToken", data);
      //   // }
      // }
      this.loaded = true;
      // axios.defaults.baseURL =
        // process.env.VUE_APP_ROOT_API_SERVER + process.env.VUE_APP_ROOT_API_PATH;
    },
    resizeParent() {
      if (window.parentIFrame) {
        window.parentIFrame.size(100);
      }
    },
  },
};
</script>

<style scoped>
#main {
  background: #f8f8f8;
  color: #313232;
}
</style>

<style>
#main a {
  color: #323232;
}
#main p {
  margin-bottom: unset;
}
</style>
